import * as React from "react";
import {cs} from "../../../../../../../../../../../common/react/chain-services";
import "./pill-list.scss";
import {keyed} from "@Common/react/keyed";

export const PillList = ({list, placeholder}) => cs(
    () => (
        <div className="pill-list pill-list-2oi">
            {!list?.length && (
                <div className="placeholder">
                    {placeholder}
                </div>
            )}
            {list?.map(({label, key, onRemove}) => cs(
                keyed(key),
                () => (
                    <div className="item">
                        {label}

                        <div className="close" onClick={onRemove}>
                            &times;
                        </div>
                    </div>
                )
            ))}
        </div>
    ),
);
